import { render, staticRenderFns } from "./User-new.vue?vue&type=template&id=59d18193&"
import script from "./User-new.vue?vue&type=script&lang=js&"
export * from "./User-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports